const vueComponents = () => {
  const dataComponents = document.querySelectorAll('[data-vue-component]');

  for (let i = 0; i < dataComponents.length; i++) {
    const el = dataComponents[i];
    const value = el.dataset.vueComponent;
    const modules = value.split(' ').map((item) => item.trim());
    for (let name = 0; name < modules.length; name++) {
      import(`./imports/${modules[name]}.js`).then((Module) => {
        const module = new Module.default(el);
        module.init();
      });
    }
  }
};

export default vueComponents;
